import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { BottomSheet, type UseModalState } from "@src/appV2/redesign/system/ui-components";

import { ReferralShareContent } from "../ReferralShareContent";

interface ReferralBottomSheetProps {
  modalState: UseModalState;
}

export function ReferralBottomSheet(props: ReferralBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet modalState={modalState}>
      <ReferralShareContent
        title="Help a friend find their next job"
        description="Refer someone looking for their next healthcare job."
        shareText={(referralLink, amount) =>
          `Hey! I found a great healthcare job through Clipboard Health. Use my link to apply and we'll both get $${amount} once you complete an interview.\n\n${referralLink}`
        }
        viewedEvent={APP_V2_APP_EVENTS.JOBS_PAGE_REFERRAL_VIEWED}
        shareClickedEvent={APP_V2_APP_EVENTS.JOBS_PAGE_REFERRAL_SHARE_CLICKED}
      />
    </BottomSheet>
  );
}
